module.exports = __webpack_public_path__ + "static/img/honor1.c4436e6.png";


//////////////////
// WEBPACK FOOTER
// ./public/aboutusImg/honor1.png
// module id = Fdcm
// module chunks = 0